<template>
    <div>
        <div class="schedule">
            <ul class="list-group">
                <li v-for="job in jobs" class="list-group-item">
                    <div class="row">
                        <div class="col-md-6">
                            <h4>{{ job.name }}</h4>
                        </div>
                        <div class="col-md-6">
                            <span v-if="job.running" class="badge badge-pill badge-success float-right">Running</span>
                            <span v-if="!job.running" class="badge badge-pill badge-danger float-right">Inactive</span>
                        </div>
                    </div>
                    <hr/>
                    <p><strong>Description:</strong> {{ job.description }}</p>
                    <hr/>
                    <div class="row">
                        <div class="col-md-6">
                            <button class="btn orcaBtn sm-btn" @click="runOnce(job)">Run Once</button>
                        </div>
                        <div class="col-md-6">
                            <button :disabled="!job.allow_recursive || job.running" class="btn orcaBtn sm-btn" @click="runRecursively(job)">Run Recursively
                            </button>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'admin_scheduler',
    data() {
        return {
            jobs: []
        }
    },
    beforeMount() {
        this.loadJobs();
    },
    methods: {
        /***********************************************************************
         *  Prepare Todo Data for Component
         ***********************************************************************/

        loadJobs() {
            // Collect all of the additions and deductions options
            axios
                .get(this.crmApiPath + 'admin/jobs')
                .then(response => {
                    this.jobs = response.data;
                });
        },
        runOnce(job) {
            this.dispatch(job, false);
        },
        runRecursively(job) {
            this.dispatch(job, true);
        },
        dispatch(job, recursive) {
            job.running = true;
            axios
                .post(this.crmApiPath + 'admin/dispatchJob', {
                    class: job.class,
                    recursive: recursive
                })
                .then(response => {
                   if(!recursive) {
                       job.running = false;
                   }
                });
        }
    }
}
</script>
